// @owners { team: patients }

/**
 * Auth0 SPA SDK raises these when the OAuth `state` in the URL no longer matches a
 * stored login transaction (refresh of callback URL, cleared cookies/storage mid-flow,
 * or a second handleRedirectCallback after the first consumed the transaction).
 * Expected user/environment noise — show UX feedback, but do not report to Sentry as errors.
 */
export const isExpectedAuth0LoginError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }

  if (error.message === 'Invalid state') {
    return true;
  }

  return (error as Error & { error?: string }).error === 'missing_transaction';
};
